namespace GeniuzPOS.Inventory {
    export interface IcStockReceiveData extends Serenity.ListRequest {
        Header?: IcStockReceiveRow;
        Details?: IcStockReceiveDtRow[];
        SysDocNo?: string;
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
